Mmg.addShortcode(

  /**
   *
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'top_menu',
  '.sc-top-menu',

  /**
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

    // Widget Declarations
    const $this = $(el);
    const $dropdownToggler = $('.header__nav-link');
    const $dropdownMenu = $('.header__dropdown');
    const $topMenu = $this.find(`${selector}__content`);
    const $menuItems = $this.find(`${selector}__toggler`);

    /**
     * Initialize the widget
     */
    (function init() {
      addEvents();
    })();

    /**
     * Handle events in the UI
     * hook on bs.collapse events to trigger top-menu
     */
    function addEvents() {
      $dropdownMenu.on("show.bs.collapse", function() {
        $topMenu.collapse('show');
      })
      $dropdownMenu.on("shown.bs.collapse", function() {
        $menuItems.attr('aria-expanded','false');
      })
      $dropdownMenu.on("hide.bs.collapse", function() {
        $topMenu.collapse('hide');
      })
    }
  }
);
